import axios from 'axios';
import { getBaseUrl } from './catalog';

// Configurar URL base por defecto
axios.defaults.baseURL = getBaseUrl();

// Configurar headers por defecto
axios.defaults.headers.common['Accept'] = 'application/json';

// Interceptor de Request para inyectar token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de Response para manejar errores globales
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejo de error 401 (No autorizado / Sesión expirada)
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token");
      
      // Solo actuar si había un token (si no había, probablemente ya estaba en login o es acceso público)
      if (token) {
        console.warn("[Axios] Sesión expirada (401). Limpiando credenciales y redirigiendo...");
        
        localStorage.removeItem("auth_token");
        sessionStorage.removeItem("auth_token");
        localStorage.removeItem("user");
        sessionStorage.removeItem("user");
        
        // Evitar bucle de redirección si ya estamos en login
        if (!window.location.pathname.includes("/login-register")) {
            window.location.href = "/login-register";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
